import api from '../services/api';
import { ITreatmentPayment } from '../shared/interfaces';

export const postTreatmentPayment = async (
  payload: any,
): Promise<ITreatmentPayment> => {
  const response = await api.post('/treatments-payments', payload);
  return response.data;
};
